import * as React from 'react';
import cn from 'classnames';
import { Space } from 'ebs-design';
import { SearchFilter, ButtonsFilter, SortFilter, SelectFilter, DatePickerFilter } from './Inputs';
import { ContextProps, FilterComposition, FiltersProps } from './interface';

const FiltersContext = React.createContext<ContextProps>({
  onChange: () => null,
});

const Filters: React.FC<FiltersProps> & FilterComposition = ({ onChange, className, children }) => {
  return (
    <FiltersContext.Provider value={{ onChange }}>
      <Space wrap className={cn(className)} justify="space-between">
        {children}
      </Space>
    </FiltersContext.Provider>
  );
};

Filters.Search = SearchFilter;
Filters.ButtonGroup = ButtonsFilter;
Filters.Sort = SortFilter;
Filters.Select = SelectFilter;
Filters.DatePickerFilter = DatePickerFilter;

export { Filters, FiltersContext };
